export const refs = {
  artistsList: document.querySelector('.artists'),
  loadMoreBtn: document.querySelector('.load-more-btn'),
  learnMoreArtistBtns: document.querySelectorAll('.learn-more-artist-btn'),
  artists: document.querySelector('.list-artists'),
  modalAlbumList: document.querySelector('.modal-list__album'),
  backdropModalElem: document.querySelector('.backdrop'),
  closeModalBtn: document.querySelector('.close-btn-modal'),
}

